"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createEntityReducer(key, entityAdapter) {
    return {
        gotOne: function (state, action) {
            var _a = action.payload, entities = _a.entities, result = _a.result;
            var entity = entities[key][result];
            entityAdapter.upsertOne(state, entity);
        },
        gotMany: function (state, action) {
            var entities = action.payload.entities;
            entityAdapter.upsertMany(state, entities[key]);
        },
        updatedOne: function (state, action) {
            var _a = action.payload, entities = _a.entities, result = _a.result;
            entityAdapter.updateOne(state, {
                id: result,
                changes: entities[key][result],
            });
        },
        updatedMany: function (state, action) {
            var entities = action.payload.entities;
            entityAdapter.upsertMany(state, entities[key]);
        },
        deletedOne: function (state, action) {
            var result = action.payload.result;
            entityAdapter.removeOne(state, result);
        },
        deleteMany: function (state, action) {
            var result = action.payload.result;
            entityAdapter.removeMany(state, result);
        },
        reset: function (state) { return entityAdapter.removeAll(state); },
    };
}
exports.default = createEntityReducer;
//# sourceMappingURL=createEntityReducer.js.map